import React from "react";
import { Images } from "../controller/Images";
import { Link } from "react-router";

export default function Custom404() {
  return (
    <div className="pt-20">
      <section className="flex flex-col md:flex-row items-center justify-between px-4 md:px-16 py-5 gap-8">
        {/* Left: Image */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            loading="eager"
            fetchPriority="high"
            src={Images.notfound}
            alt="No job available"
            className="max-w-md w-full"
          />
        </div>

        {/* Right: Text */}
        <div className="w-full md:w-1/2 text-center md:text-left">
          <h1 className="text-6xl sm:text-8xl font-bold text-primary">404</h1>
          <h2 className="text-2xl sm:text-3xl font-semibold mt-3">
            Oops! Page Not Found 🚧
          </h2>
          <p className="mt-3 text-gray-600 text-base sm:text-lg leading-relaxed">
            The page you’re looking for doesn’t exist or has been moved.
            <br />
            But don’t worry—you can still explore our site below.
          </p>
          <div className="mt-8">
            <Link
              to="/"
              className="inline-block px-6 py-3 bg-gradient-to-r from-[#22c55e] to-[#15803d] text-white font-semibold rounded-xl shadow-md hover:from-[#16a34a] hover:to-[#14532d] transition duration-300"
            >
              Go to Home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
